import * as React from "react";
import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { TimeClock } from "@mui/x-date-pickers/TimeClock";
import { Box, InputLabel, useTheme, Popover, TextField } from "@mui/material";

export default function TimeClockComponent({ label, name, value, onChange,showLabel }) {
  const theme = useTheme();
  const [selectedTime, setSelectedTime] = React.useState(
    value ? dayjs(value) : dayjs()
  );
  const [anchorEl, setAnchorEl] = React.useState(null);

  // Update parent component when time changes
  React.useEffect(() => {
    onChange(name, selectedTime.format("YYYY-MM-DD HH:mm")); // 24-hour format
  }, [selectedTime]);

  // Open clock picker
  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  // Close clock picker
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box sx={{ mt: 2, width: "100%" }}>


      {/* TextField to trigger TimeClock */}
      <TextField
        fullWidth
        name={name}
        value={selectedTime.format("HH:mm")} // 24-hour format
        onClick={handleOpen}
        readOnly
        sx={{
          width:"100%",
          cursor: "pointer",
          backgroundColor: theme?.guest?.bgColor,
          "& .MuiOutlinedInput-root": {
            border: "none",
          },
        }}
      />

      {/* Popover for TimeClock */}
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <TimeClock
            value={selectedTime}
            onChange={(newTime) => {
              setSelectedTime(newTime);
            }}
            ampm={false} // 24-hour format
            minutesStep={1} // Allows minute selection with 1-minute steps
          />
        </LocalizationProvider>
      </Popover>
    </Box>
  );
}
